import { SipTopBannerModule } from './../common/sip-top-banner/sip-top-banner.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommentBannerComponent } from './components/comment-banner/comment-banner.component';
import { MainComponent } from './components/main/main.component';
import { ShareBannerComponent } from './components/share-banner/share-banner.component';
import { UpdateSummaryComponent } from './components/update-summary/update-summary.component';
import { UpdatePageRoutingModule } from './update-page-routing.module';
import { InViewportModule } from 'ng-in-viewport';
import { SharedModule } from '../shared/shared.module';
import { UpdateBannerComponent } from './components/update-banner/update-banner.component';
import { SipTickerModule } from '../common/sip-ticker/sip-ticker.module';
import { TimelineV2Component } from './components/timeline-v2/timeline-v2.component';
import { OfferCardModule } from '../common/offer-card/offer-card.module';
import { ChatWithUsModule } from '../common/chat-with-us/chat-with-us.module';
import { CommentCardModule } from '../common/comment-card/comment-card.module';
import { CommonHeaderModule } from '../common/common-header/common-header.module';
import { DonateNowModule } from '../common/donate-now/donate-now.module';
import { FbShareModule } from '../common/fb-share/fb-share.module';
import { FooterModule } from '../common/footer/footer.module';
import { ImpactDockerModule } from '../common/impact-docker/impact-docker.module';
import { InsuranceCardModule } from '../common/insurance-card/insurance-card.module';
import { InsuranceSuccessfulDialogModule } from '../common/insurance-successful-dialog/insurance-successful-dialog.module';
import { MonthlyCardModule } from '../common/monthly-card/monthly-card.module';
import { OfferNoteModule } from '../common/offer-note/offer-note.module';
import { PaymentModule } from '../common/payment/payment.module';
import { SimilarFundraiserModule } from '../common/similar-fundraiser/similar-fundraiser.module';
import { UpdateModule } from '../common/update/update.module';
import { WhatsappShareModule } from '../common/whatsapp-share/whatsapp-share.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { SipTopBannerV2Component } from '../common/sip-top-banner-v2/sip-top-banner-v2.component';

@NgModule({
  imports: [
    CommonModule,
    UpdatePageRoutingModule,
    UpdateModule,
    FbShareModule,
    WhatsappShareModule,
    CommentCardModule,
    CommonHeaderModule,
    FooterModule,
    InViewportModule,
    InsuranceCardModule,
    SharedModule,
    MonthlyCardModule,
    SimilarFundraiserModule,
    InsuranceSuccessfulDialogModule,
    ImpactDockerModule,
    ChatWithUsModule,
    DonateNowModule,
    PaymentModule,
    SipTickerModule,
    SipTopBannerModule,
    OfferNoteModule,
    OfferCardModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    SipTopBannerV2Component
  ],
  declarations: [
    UpdateSummaryComponent,
    MainComponent,
    CommentBannerComponent,
    ShareBannerComponent,
    UpdateBannerComponent,
    TimelineV2Component
  ],
  bootstrap: [MainComponent]
})
export class UpdatePageModule { }
